"use strict";

/*==============================================================================
TRESTLE CORPORATE PARTNER ONBOARDING
FRONT-END SUBMISSION ENGINE

Brand        : TRESTLE by Diafemme
File         : TRESTLE_Corporate_Onboarding.js
Version      : 1.0

Purpose
-------
• Validate Corporate Partner application
• Submit form data to Google Apps Script
• Prevent duplicate submission
• Display success / error state
==============================================================================*/


const TrestleCorporateOnboarding = (() => {


/*==============================================================================
CONFIG
==============================================================================*/

const ENDPOINT =
    "https://script.google.com/macros/s/AKfycbwCwIpuPxD0nRKF4SnBxA4ehf8c5PejjBGcPvLT9sdxvq58UGVvJ3qXawo_QBspBfqr/exec";


/*==============================================================================
STATE
==============================================================================*/

let root = null;

let form = null;

let submitButton = null;

let statusBox = null;

let successBox = null;

let referenceBox = null;

let submitting = false;


/*==============================================================================
INITIALIZE
==============================================================================*/

function initialize(){

    root =
        document.getElementById(
            "trCorporateOnboarding"
        );


    if(!root){

        return;

    }


    form =
        document.getElementById(
            "trCorporateForm"
        );


    submitButton =
        document.getElementById(
            "trCorporateSubmit"
        );


    statusBox =
        document.getElementById(
            "trCorporateFormStatus"
        );


    successBox =
        document.getElementById(
            "trCorporateSuccess"
        );


    referenceBox =
        document.getElementById(
            "trCorporateReference"
        );


    if(!form){

        return;

    }


    bindForm();


    console.info(
        "TRESTLE Corporate Onboarding Ready"
    );

}


/*==============================================================================
BIND FORM
==============================================================================*/

function bindForm(){

    form.addEventListener(

        "submit",

        handleSubmit

    );

}


/*==============================================================================
SUBMIT
==============================================================================*/

async function handleSubmit(event){

    event.preventDefault();


    if(submitting){

        return;

    }


    clearStatus();


    if(
        !validateForm()
    ){

        showStatus(
            "Please complete the required fields before submitting.",
            "error"
        );

        return;

    }


    const formData =
        new FormData(
            form
        );


    submitting = true;

    setSubmittingState(
        true
    );


    try{

        const response =
            await fetch(

                ENDPOINT,

                {
                    method: "POST",
                    body: formData
                }

            );


        if(!response.ok){

            throw new Error(
                "Submission request failed."
            );

        }


        const result =
            await response.json();


        if(
            !result ||
            result.success !== true
        ){

            throw new Error(
                result && result.message
                    ?
                    result.message
                    :
                    "Application could not be submitted."
            );

        }


        showSuccess(
            result.applicationId || ""
        );

    }

    catch(error){

        console.error(
            "TRESTLE Corporate Application Error:",
            error
        );


        showStatus(

            error.message ||
            "We could not submit your application at this time. Please try again.",

            "error"

        );

    }

    finally{

        submitting = false;

        setSubmittingState(
            false
        );

    }

}


/*==============================================================================
VALIDATION
==============================================================================*/

function validateForm(){

    const requiredFields =
        form.querySelectorAll(
            "[required]"
        );

    let valid = true;


    requiredFields.forEach(field => {

        field.classList.remove(
            "has-error"
        );


        if(field.type === "checkbox"){

            if(!field.checked){

                field.classList.add(
                    "has-error"
                );

                valid = false;

            }

            return;

        }


        if(
            !String(field.value || "").trim() ||
            !field.checkValidity()
        ){

            field.classList.add(
                "has-error"
            );

            valid = false;

        }

    });


    /*----------------------------------------------------------
    CORPORATE DOMAIN VALIDATION
    ----------------------------------------------------------*/

    const domainField =
        form.querySelector(
            '[name="approved_domain"]'
        );

    if(domainField){

        let domain =
            String(
                domainField.value || ""
            )
            .trim()
            .toLowerCase();


        domain =
            domain
            .replace(/^https?:\/\//, "")
            .replace(/^www\./, "")
            .replace(/^@/, "")
            .replace(/\/.*$/, "");


        const validDomain =
            /^[a-z0-9.-]+\.[a-z]{2,}$/i
            .test(domain);


        if(
            !validDomain ||
            domain.includes("@")
        ){

            domainField.classList.add(
                "has-error"
            );

            valid = false;

        }

        else{

            domainField.value =
                domain;

        }

    }


    if(!valid){

        const firstError =
            form.querySelector(
                ".has-error"
            );


        if(firstError){

            firstError.scrollIntoView({

                behavior: "smooth",
                block: "center"

            });

            firstError.focus();

        }

    }


    return valid;

}


/*==============================================================================
SUBMITTING STATE
==============================================================================*/

function setSubmittingState(active){

    if(!submitButton){

        return;

    }


    submitButton.disabled =
        active;


    submitButton.textContent =
        active
        ?
        "Submitting Application..."
        :
        "Apply to Become a TRESTLE Corporate Partner";

}


/*==============================================================================
STATUS
==============================================================================*/

function showStatus(
    message,
    type
){

    if(!statusBox){

        return;

    }


    statusBox.hidden =
        false;


    statusBox.textContent =
        message;


    statusBox.classList.remove(
        "is-error",
        "is-success"
    );


    if(
        type === "error"
    ){

        statusBox.classList.add(
            "is-error"
        );

    }

    else{

        statusBox.classList.add(
            "is-success"
        );

    }

}


/*==============================================================================
CLEAR STATUS
==============================================================================*/

function clearStatus(){

    if(!statusBox){

        return;

    }


    statusBox.hidden =
        true;


    statusBox.textContent =
        "";


    statusBox.classList.remove(
        "is-error",
        "is-success"
    );

}


/*==============================================================================
SUCCESS
==============================================================================*/

function showSuccess(applicationId){

    if(form){

        form.hidden =
            true;

    }


    if(successBox){

        successBox.hidden =
            false;

    }


    if(referenceBox){

        referenceBox.textContent =
            applicationId
            ?
            "Application Reference: " +
              applicationId
            :
            "";

    }


    successBox?.scrollIntoView({

        behavior: "smooth",

        block: "start"

    });

}


/*==============================================================================
PUBLIC API
==============================================================================*/

return {

    initialize

};

})();


/*==============================================================================
PUBLIC NAMESPACE
==============================================================================*/

window.TrestleCorporateOnboarding =
    TrestleCorporateOnboarding;


/*==============================================================================
BOOT
==============================================================================*/

if(
    document.readyState ===
    "loading"
){

    document.addEventListener(

        "DOMContentLoaded",

        () => {

            TrestleCorporateOnboarding.initialize();

        }

    );

}

else{

    TrestleCorporateOnboarding.initialize();

}


/*==============================================================================
END
==============================================================================*/